<template>
  <div class="delivery-container">
    <!-- begin banner -->
    <div
      class="banner"
      :style="
        `${
          storeInfo && storeInfo.background
            ? 'background: url( ' +
              storeInfo.background.url +
              ');background-size: cover;background-position: center center'
            : ''
        }`
      "
    >
      <div class="overlay"></div>
      <div class="banner-container" fill-height>
        <v-layout column align-center justify-center>
          <h1 class="banner-title">{{ $t("delivery.banner_title") }}</h1>
          <!-- <div class="banner-content">{{ $t("delivery.banner_content") }}</div> -->
        </v-layout>
      </div>
    </div>
    <!-- begin banner -->

    <!-- begin loading -->
    <div v-if="pageLoading" class="page-loading-container">
      <v-progress-circular
        :size="60"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <!-- end loading -->

    <!-- begin 菜品列表 -->
    <div class="menu-container" v-show="!pageLoading">
      <v-layout class="menu-layout">
        <v-layout
          ref="menuWrapper"
          class="menu-layout"
          :column="breakpoint.mdAndDown"
        >
          <v-flex class="sidebar" shrink xs2 id="sidebar">
            <div
              class="sidebar-wrapper"
              :class="{ 'fixed-bar': sidebarFixed, 'has-cookie': showCookie }"
            >
              <v-layout class="sidebar-nav">
                <div
                  class="sidebar-nav__item side-list-hook"
                  v-for="(item, index) in categoryList"
                  :key="item.guid"
                  :id="`sidebar-${index}`"
                  :class="{ active: index === activeCategory }"
                  @click="goAnchor($event, `#category-${index}`, index)"
                >
                  {{ item.name }}
                </div>
              </v-layout>
            </div>
          </v-flex>
        </v-layout>
        <v-flex class="menu-layout-content" ref="foodsWrapper" xs9>
          <div
            class="delivery food-list-hook"
            v-for="(category, index) in deliveryMenu"
            :key="category.guid"
            :id="`category-${index}`"
          >
            <div class="menu-heading">
              <h4>{{ category.name }}</h4>
            </div>
            <div class="delivery-list">
              <v-layout
                class="delivery-list__item"
                align-center
                v-for="item in category.commodites"
                :key="item.guid"
              >
                <v-flex shrink @click="goToDeliveryDetail(item)">
                  <img
                    class="cover"
                    :src="item.cover.url"
                    v-show="item.cover.url"
                    alt=""
                  />
                  <div class="cover" v-show="!item.cover.url" />
                </v-flex>
                <v-flex
                  class="delivery-info"
                  fill-height
                  @click="goToDeliveryDetail(item)"
                >
                  <v-layout column fill-height justify-space-between>
                    <div class="delivery-title">{{ item.name }}</div>
                    <div class="delivery-content">
                      {{ item.description }}
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex fill-height>
                  <v-layout column align-end justify-space-between>
                    <v-flex class="delivery-price" shrink>
                      €{{ item.price | fixed(2, true) }}
                    </v-flex>
                    <v-flex
                      :class="{ 'delivery-operate': true, right: !item.num }"
                      shrink
                      v-if="
                        item.garnish.length == 0 && storeInfo.orderScanner == 1
                      "
                    >
                      <v-icon
                        :class="{
                          icon: true
                        }"
                        @click="handleMinusFromCart(item.guid)"
                        v-if="item.num"
                        >remove_circle_outline</v-icon
                      >
                      <div v-if="item.num">
                        <span class="show-num">{{ item.num }}</span>
                      </div>
                      <v-icon
                        :class="{
                          icon: true,
                          'check-icon': checked_guid == item.guid
                        }"
                        @click="handleAddToCart(item, index, $event)"
                        >add_circle_outline</v-icon
                      >
                    </v-flex>
                    <v-flex
                      :class="{ 'delivery-operate': true, right: true }"
                      shrink
                      v-if="
                        item.garnish.length != 0
                      "
                    >
                      <v-icon
                        :class="{
                          icon: true
                        }"
                        @click="goToFoodDetail(item)"
                        >add_circle_outline</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <!-- end 菜品列表 -->

    <!-- begin 底部菜单 -->
    <div
      class="bottom-btn-container"
      v-if="cartNums != 0 && storeInfo.orderScanner == 1"
    >
      <div class="right-container" @click="onProceedToCheckout">
        <div class="num">({{ cartNums }})</div>
        <!-- 查看 选好了 -->
        <div>{{ $t("delivery.checkedMenu") }}</div>
      </div>
    </div>

    <div
      class="bottom-btn-container bottom-disabled-container"
      v-if="cartNums == 0 && storeInfo.orderScanner == 1"
    >
      <div class="right-container">
        <!-- 查看 选好了 -->
        <div>{{ $t("delivery.checkedMenu") }}</div>
      </div>
    </div>
    <!-- end 底部菜单 -->

    <!-- bengin 动效小球 -->
    <div class="ball-container">
      <div v-for="(ball, index) in balls" :key="index">
        <transition
          name="cast-ball"
          @before-enter="ballBeforeEnter"
          @enter="ballEnter"
          @after-enter="ballAfterEnter"
        >
          <div class="horiz-ball" v-show="ball.show">
            <div class="ball"></div>
          </div>
        </transition>
      </div>
    </div>
    <!-- end 动效小球 -->

    <!-- begin 扫码超时 -->
    <v-dialog v-model="dialog" width="500">
      <v-alert dense outlined type="warning" v-model="dialog">
        {{ $t("delivery.timeout") }}
      </v-alert>
    </v-dialog>
    <!-- end 扫码超时 -->

    <!-- begin 选择属性 -->
    <v-dialog v-model="isShowAttributes" max-width="500px">
      <v-card color="#fff">
        <div
          class="check-attributes-container-layout"
          v-if="attributes && attributes.length != 0"
        >
          <div class="attributes-title">
            <div>{{ $t("delivery.attribute") }}</div>
          </div>
          <div class="attributes-subtitle">
            <div>{{ $t("delivery.attribute_tip") }}</div>
          </div>
          <div class="attributes-content">
            <div
              v-for="(item, index) in attributes"
              :key="index"
              :class="{ item: true, active: item.check }"
              @click="checkAttr(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <button
            class="button attribute-button"
            @click="handleAddToCartAttributes($event)"
          >
            {{ $t("delivery_detail.addToCart") }}
          </button>
        </div>
      </v-card>
    </v-dialog>
    <!-- end 选择属性 -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import { fixed } from "../../../utils";
import moment from "moment";
import $ from "jquery";

export default {
  data() {
    return {
      offsetTop: 0,
      sidebarFixed: false,
      checked_guid: "",
      pageLoading: false,
      total: 0,
      discount: 0,
      discountAmount: 0,
      actuallyPaidAmount: 0,
      activeDeliveryMenu: {
        commodites: []
      },
      balls: [
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false },
        { show: false }
      ],
      castBalls: [],
      timeout: false,
      dialog: false,

      listHeight: [],
      sideHeight: [],
      scrollY: 0, // 右侧的y值

      attributes: [],
      isShowAttributes: false
    };
  },

  components: {},

  created() {
    this.initData();
    if (this.$route.query.storeGuid) {
      this.setStoreId(this.$route.query.storeGuid);
      this.getStoreInfo();
    }

    if (this.$route.query.startTime) {
      const startTime = this.$route.query.startTime;
      const now = moment().unix();
      if (now - startTime > 600) {
        this.timeout = true;
        this.dialog = true;
      }
    }
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.getOffset();
    this.activeDeliveryMenu = this.deliveryMenu[this.activeCategory];
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  computed: {
    ...mapState([
      "deliveryMenu",
      "showCookie",
      "storeInfo",
      "carts",
      "myOrder",
      "activeCategory"
    ]),
    ...mapGetters(["categoryList", "cart"]),
    options() {
      return {
        duration: 10,
        offset: this.showCookie ? 70 : 0,
        easing: "easeInOutCubic"
      };
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    cartNums() {
      return this.cart.items.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.num;
      }, 0);
    },
    activeCategory() {
      //计算到达哪个区域的区间的时候的对应的索引值
      //  利用 listHeight 存放 每一块 对应的高度
      let index = 0;

      if (this.scrollY == 0) {
        index = 0;
      } else {
        for (let i = 0, l = this.listHeight.length; i < l; i++) {
          let menuHeight_fir = this.listHeight[i]; // 当前menu 子块区域的 高度
          let menuHeight_sec = this.listHeight[i + 1]; // 下一个menu 子块区域的 高度

          //  当滑到底部时，menuHeight_sec 为 underfined,
          //  需要确定滑到俩个高度区间

          if (
            !menuHeight_sec ||
            (this.scrollY > menuHeight_fir && this.scrollY < menuHeight_sec)
          ) {
            index = i;

            this.scrollSidebar(index);

            return i;
          }
        }
      }

      return index;
    }
  },
  methods: {
    ...mapMutations([
      "addToCart",
      "resetCart",
      "removeFromCart",
      "minusFromCart",
      "setStoreId",
      "setActiveCategoryIndex",
      "setDelivery"
    ]),
    ...mapActions(["getDeliveries", "getStoreInfo"]),

    /**
     * 切换分类
     */
    goAnchor(e, selector, index) {
      e.preventDefault();
      this.setActiveCategoryIndex(index);

      this.activeDeliveryMenu = this.deliveryMenu[this.activeCategory];
      this.$vuetify.goTo(selector, this.options);

      // this.goTop();
      this.scrollSidebar(index);
    },

    scrollSidebar(checkIndex) {
      let Total = this.sideHeight.reduce(function(pre, cur, index) {
        if (index > checkIndex - 1) {
          return pre + 0;
        }
        return pre + cur;
      }, 0);

      this.$nextTick(() => {
        this.handleResize();
        document.querySelector(".sidebar-wrapper").scrollTop = Total;
      });
    },

    /**
     * 回到顶部
     */
    goTop() {
      let timer = null;
      timer = setInterval(() => {
        let topDistance =
          document.documentElement.scrollTop || document.body.scrollTop;
        let moveDistance = Math.floor(-topDistance / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          topDistance + moveDistance;
        if (topDistance === 0) {
          clearInterval(timer);
        }
      }, 30);
    },

    /**
     * 去结算
     */
    onProceedToCheckout() {
      if (this.timeout) {
        this.dialog = true;
        return;
      }
      this.$router.push({
        name: "store/checkout"
      });
    },

    /**
     * 添加至本地购物车
     * @param {*} guid 商品id
     * @param {*} ev event事件对象
     */
    async handleAddToCart(item, index, ev) {
      if (this.timeout) {
        this.dialog = true;
        return;
      }

      this.delivery = item;
      if (!item.num && item.attributes.length != 0) {
        this.attributes = item.attributes;
        this.isShowAttributes = true;
      } else {
        const payload = {
          guid: item.guid,
          num: 1
        };

        this.checked_guid = item.guid;

        setTimeout(() => {
          this.checked_guid = "";
        }, 3000);

        this.addToCart(payload);
        this.castBall(ev.target);
      }
    },

    handleAddToCartAttributes(ev) {
      let cart_attributes = [];
      this.attributes.map(item1 => {
        if (item1.check) {
          cart_attributes.push(item1.guid);
        }
      });
      this.addToCart({
        num: 1,
        guid: this.delivery.guid,
        attributes: cart_attributes
      });

      this.isShowAttributes = false;
      this.castBall(ev.target);
    },

    /**
     * 选中可用小球
     */
    castBall(el) {
      // 找到第一个show为false（可用）的小球，然后就跳出循环
      this.balls.some(ball => {
        if (!ball.show) {
          ball.show = true;
          ball.el = el;
          this.castBalls.push(ball);
          return true;
        }
      });
    },

    ballBeforeEnter(el) {
      let len = this.balls.length;
      for (let i = 0; i < len; i++) {
        let ball = this.balls[i];
        if (ball.show) {
          let rect = ball.el.getBoundingClientRect();

          const winWidth = this.$vuetify.breakpoint.width;

          let x = rect.left - winWidth / 6;
          let y = rect.top - window.innerHeight + 40;
          el.style.webkitTransform = `translate3d(${x}px,0,0)`;
          el.style.transform = `translate3d(${x}px,0,0)`;
          let child = el.children[0];
          child.style.transform = `translate3d(0,${y}px,0)`;
          child.style.webkitTransform = `translate3d(0,${y}px,0)`;
        }
      }
    },

    ballEnter(el, done) {
      el.timer = setTimeout(() => {
        el.style.webkitTransform = `translate3d(0,0,0)`;
        el.style.transform = `translate3d(0,0,0)`;
        let child = el.children[0];
        child.style.transform = `translate3d(0,0,0)`;
        child.style.webkitTransform = `translate3d(0,0,0)`;
        el.addEventListener("transitionEnd", done);
        el.addEventListener("webkitTransitionEnd", done);
      }, 30);
    },

    ballAfterEnter(el) {
      let ball = this.castBalls.shift();
      if (ball) {
        ball.show = false;
        el.style.display = "none";
        clearTimeout(el.timer);
      }
    },

    handleRemoveFromCart(guid) {
      this.removeFromCart(guid);
    },
    handleMinusFromCart(guid) {
      if (this.timeout) {
        this.dialog = true;
        return;
      }
      this.minusFromCart({
        num: 1,
        guid
      });
    },

    /**
     * 去商品套餐详情
     */
    goToFoodDetail(item, showImage) {
      if (item.garnish.length == 0) {
        return;
      }
      this.$router.push({
        name: "good/detail",
        params: { id: item.guid },
        query: {
          showImage: showImage
        }
      });
    },

    /**
     * 去商品详情
     */
    goToDeliveryDetail(item) {
      if (item.garnish.length != 0) {
        this.goToFoodDetail(item, 1);
      } else {
        this.$router.push({
          name: "store/delivery/detail",
          params: { id: item.guid }
        });
      }
    },

    async initData() {
      this.pageLoading = this.deliveryMenu.length === 0;
      await this.getDeliveries();
      this.pageLoading = false;
      this.$nextTick(() => {
        this._calculateHeight();
        this._calculateSideHeight();
      });
    },

    _calculateHeight() {
      //  获取 li 通过food-list-hook
      let foodList = this.$refs.foodsWrapper.querySelectorAll(
        ".food-list-hook"
      );
      let height = 0; // 初始化高度
      this.listHeight.push(height); //  把第一个高度存入数组
      //通过循环foodList下的dom结构，将每一个li的高度依次送入数组
      for (let i = 0, l = foodList.length; i < l; i++) {
        let item = foodList[i]; //每一个item都是刚才获取的food的每一个dom
        height += item.clientHeight; //获取每一个foods内部块的高度
        this.listHeight.push(height); // 将获取的值存放到数组里
      }
    },

    _calculateSideHeight() {
      //  获取 li 通过side-list-hook
      let foodList = this.$refs.menuWrapper.querySelectorAll(".side-list-hook");
      let height = 0; // 初始化高度

      this.sideHeight.push(height); //  把第一个高度存入数组
      //通过循环foodList下的dom结构，将每一个li的高度依次送入数组
      for (let i = 0, l = foodList.length; i < l; i++) {
        let item = foodList[i]; //每一个item都是刚才获取的food的每一个dom
        height += item.clientHeight; //获取每一个foods内部块的高度
        this.sideHeight.push(height); // 将获取的值存放到数组里
      }
    },

    getOffset() {
      this.$nextTick(function() {
        this.handleResize();
        let header = document.getElementById("sidebar");
        this.offsetTop = header.offsetTop;
      });
    },

    handleScroll() {
      // 得到页面滚动的距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      let offsetTop = this.offsetTop;
      let orderOffsetTop = this.orderOffsetTop - 90 - 10;

      if (this.showCookie) {
        offsetTop -= this.$vuetify.breakpoint.xs ? 80 : 60;
        orderOffsetTop -= this.$vuetify.breakpoint.xs ? 80 : 60;
      }

      let sidebarFixed = scrollTop > offsetTop;
      let orderFixed = scrollTop > orderOffsetTop;

      this.sidebarFixed = sidebarFixed;
      this.orderFixed = orderFixed;

      this.scrollY = scrollTop < 150 ? scrollTop : scrollTop - 150;
    },

    handleResize() {
      let orderWidth = "auto";
      let sidebarWidth = "auto";

      if (!this.breakpoint.mdAndDown) {
        orderWidth = $("#order").width();
        sidebarWidth = $("#sidebar").width();
      }

      $(".order").width(orderWidth);
      $(".sidebar-wrapper").width(sidebarWidth);

      let slide_height = $(window).height() - (this.showCookie ? 120 : 50);
      $(".fixed-bar").css("max-height", slide_height + "px");
      $(".fixed-order").css("max-height", slide_height + "px");
    },

    /**
     * 选择属性标签
     */
    checkAttr(item) {
      let attributes = this.attributes.slice(0);

      attributes.map((att_item, index) => {
        if (att_item.guid == item.guid) {
          attributes[index].check = !attributes[index].check;
        }
      });

      let cart_attributes = [];
      attributes.map(item1 => {
        if (item1.check) {
          cart_attributes.push(item1.guid);
        }
      });

      let carts = this.carts.slice(0);

      carts.map((item1, index) => {
        if (item1.guid == this.delivery.guid) {
          carts[index].attributes = cart_attributes;
        }
      });

      this.resetCart(carts);

      this.setDelivery({
        ...this.delivery,
        attributes
      });

      this.attributes = attributes;
    }
  },
  watch: {
    deliveryMenu() {
      // 默认展示第一个分类的菜品
      this.activeDeliveryMenu = this.deliveryMenu[this.activeCategory];
    },
    "cart.items"(items) {
      // 通过对比购物车和菜单列表 在菜单列表加上数量num字段
      let menuList = this.activeDeliveryMenu.commodites || [];

      this.activeDeliveryMenu.commodites.map((menu_item, menu_index) => {
        menuList[menu_index].num = 0;

        items.map(cart_item => {
          if (menu_item.guid == cart_item.guid) {
            menuList[menu_index].num = cart_item.num;
          }
        });
      });

      this.activeDeliveryMenu.commodites = menuList || [];
    },
    activeDeliveryMenu() {
      // 通过对比购物车和菜单列表 在菜单列表加上数量num字段
      let menuList = this.activeDeliveryMenu.commodites || [];

      this.activeDeliveryMenu.commodites.map((menu_item, menu_index) => {
        menuList[menu_index].num = 0;

        this.cart.items.map(cart_item => {
          if (menu_item.guid == cart_item.guid) {
            menuList[menu_index].num = cart_item.num;
          }
        });
      });

      this.activeDeliveryMenu.commodites = menuList || [];
    },
    "breakpoint.mdAndDown"() {
      this.getOffset();
      this.handleScroll();
    },
    offsetTop() {
      this.getOffset();
      this.handleScroll();
    },
    showCookie() {
      this.getOffset();
      this.handleScroll();
    },
    pageLoading() {
      this.getOffset();
      this.handleScroll();
    }
  },
  filters: {
    fixed
  }
};
</script>

<style scoped lang="sass" src="./delivery-list.sass"></style>
